export default {"src":"/_next/static/media/icon.47a78c62.svg","height":31,"width":58};